import { useQuery } from '@tanstack/react-query';
import type { SelectMedicationParams } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchSelectMedication } from '../api/selectMedication.js';
import { rxKeys } from './keys.js';

export function selectMedicationQueryDefinition(params: SelectMedicationParams) {
  return {
    queryKey: rxKeys.medicationSelect(params),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchSelectMedication(params, signal),
    meta: {
      toast: {
        title: 'Could not select medication',
        description: 'Medication details could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function useSelectMedicationQuery(params: SelectMedicationParams | undefined) {
  const enabled = params !== undefined;
  return useQuery({
    queryKey: params
      ? rxKeys.medicationSelect(params)
      : (['rx', 'medications', 'select', ''] as const),
    queryFn: ({ signal }: { signal?: AbortSignal }) => {
      if (!params) {
        throw new Error('Missing select medication params');
      }
      return fetchSelectMedication(params, signal);
    },
    enabled,
  });
}
